import DashboardHome from "./pages/DashboardHome";

export const dashboardRoutes = [
  {
    // No role gate — the dashboard is where every signed-in user lands, and it
    // only ever renders the caller's own data. Gating it by an enumerated role
    // list meant any role missing from that list (president, examiner,
    // moderator…) got bounced to /unauthorized.
    path: "/dashboard",
    element: <DashboardHome />,
  },
];
